// fsm
export const FSM_NAME_CHANGED = 'FSM_NAME_CHANGED';
export const FSM_STATE_MOVED = 'FSM_STATE_MOVED';
export const FSM_STATE_ADDED = 'FSM_STATE_ADDED';
export const FSM_STATE_SELECTED = 'FSM_STATE_SELECTED';
export const FSM_STATE_NAME_CHANGED = 'FSM_STATE_NAME_CHANGED';
export const FSM_STATE_DELETED = 'FSM_STATE_DELETED';
export const FSM_STATES_SET = 'FSM_STATES_SET';
export const FSM_INITIAL_STATE_CHANGED = 'FSM_INITIAL_STATE_CHANGED';
export const FSM_INITIAL_STATE_REMOVED = 'FSM_INITIAL_STATE_REMOVED';
export const FSM_ACCEPT_STATE_ADDED = 'FSM_ACCEPT_STATE_ADDED';
export const FSM_ACCEPT_STATE_REMOVED = 'FSM_ACCEPT_STATE_REMOVED';
export const FSM_ACCEPT_STATES_SET = 'FSM_ACCEPT_STATES_SET';
export const FSM_TRANSITION_ADDED = 'FSM_TRANSITION_ADDED';
export const FSM_TRANSITION_REMOVED = 'FSM_TRANSITION_REMOVED';
export const FSM_INPUT_SYMBOL_ADDED = 'FSM_INPUT_SYMBOL_ADDED';
export const FSM_INPUT_ALPHABET_SET = 'FSM_INPUT_ALPHABET_SET';
export const FSM_INPUT_STRING_SET = 'FSM_INPUT_STRING_SET';
export const FSM_EXECUTION_PATH_SET = 'FSM_EXECUTION_PATH_SET';
export const FSM_STEP_INPUT = 'FSM_STEP_INPUT';
export const FSM_RUN_INPUT = 'FSM_RUN_INPUT';
export const FSM_RESTART_INPUT = 'FSM_RESTART_INPUT';
export const FSM_ADD_TEST_CASE = 'FSM_ADD_TEST_CASE';
export const FSM_REMOVE_TEST_CASE = 'FSM_REMOVE_TEST_CASE';
export const FSM_RUN_TEST_CASES = 'FSM_RUN_TEST_CASES';
export const FSM_RESET_TEST_CASES = 'FSM_RESET_TEST_CASES';
export const FSM_INITIALIZE_TEST_CASES_FROM_CSV_STRING = 'FSM_INITIALIZE_TEST_CASES_FROM_CSV_STRING';
export const FSM_INITIALIZED_FROM_JSON_STRING = 'FSM_INITIALIZED_FROM_JSON_STRING';
export const FSM_RESET = 'FSM_RESET';

// pda
export const PDA_NAME_CHANGED = 'PDA_NAME_CHANGED';
export const PDA_STATE_MOVED = 'PDA_STATE_MOVED';
export const PDA_STATE_ADDED = 'PDA_STATE_ADDED';
export const PDA_STATE_SELECTED = 'PDA_STATE_SELECTED';
export const PDA_STATE_NAME_CHANGED = 'PDA_STATE_NAME_CHANGED';
export const PDA_STATE_DELETED = 'PDA_STATE_DELETED';
export const PDA_STATES_SET = 'PDA_STATES_SET';
export const PDA_INITIAL_STATE_CHANGED = 'PDA_INITIAL_STATE_CHANGED';
export const PDA_INITIAL_STATE_REMOVED = 'PDA_INITIAL_STATE_REMOVED';
export const PDA_ACCEPT_STATE_ADDED = 'PDA_ACCEPT_STATE_ADDED';
export const PDA_ACCEPT_STATE_REMOVED = 'PDA_ACCEPT_STATE_REMOVED';
export const PDA_ACCEPT_STATES_SET = 'PDA_ACCEPT_STATES_SET';
export const PDA_TRANSITION_ADDED = 'PDA_TRANSITION_ADDED';
export const PDA_TRANSITION_REMOVED = 'PDA_TRANSITION_REMOVED';
export const PDA_INPUT_SYMBOL_ADDED = 'PDA_INPUT_SYMBOL_ADDED';
export const PDA_INPUT_ALPHABET_SET = 'PDA_INPUT_ALPHABET_SET';
export const PDA_STACK_SYMBOL_ADDED = 'PDA_STACK_SYMBOL_ADDED';
export const PDA_STACK_ALPHABET_SET = 'PDA_STACK_ALPHABET_SET';
export const PDA_INITIAL_STACK_SYMBOL_CHANGED = 'PDA_INITIAL_STACK_SYMBOL_CHANGED';
export const PDA_INITIAL_STACK_SYMBOL_REMOVED = 'PDA_INITIAL_STACK_SYMBOL_REMOVED';
export const PDA_INPUT_STRING_SET = 'PDA_INPUT_STRING_SET';
export const PDA_EXECUTION_PATH_SET = 'PDA_EXECUTION_PATH_SET';
export const PDA_STEP_INPUT = 'PDA_STEP_INPUT';
export const PDA_RUN_INPUT = 'PDA_RUN_INPUT';
export const PDA_RESTART_INPUT = 'PDA_RESTART_INPUT';
export const PDA_ADD_TEST_CASE = 'PDA_ADD_TEST_CASE';
export const PDA_REMOVE_TEST_CASE = 'PDA_REMOVE_TEST_CASE';
export const PDA_RUN_TEST_CASES = 'PDA_RUN_TEST_CASES';
export const PDA_RESET_TEST_CASES = 'PDA_RESET_TEST_CASES';
export const PDA_INITIALIZE_TEST_CASES_FROM_CSV_STRING = 'PDA_INITIALIZE_TEST_CASES_FROM_CSV_STRING';
export const PDA_INITIALIZED_FROM_JSON_STRING = 'PDA_INITIALIZED_FROM_JSON_STRING';
export const PDA_RESET = 'PDA_RESET';

// tm
export const TM_NAME_CHANGED = 'TM_NAME_CHANGED';
export const TM_STATE_MOVED = 'TM_STATE_MOVED';
export const TM_STATE_ADDED = 'TM_STATE_ADDED';
export const TM_STATE_SELECTED = 'TM_STATE_SELECTED';
export const TM_STATE_NAME_CHANGED = 'TM_STATE_NAME_CHANGED';
export const TM_STATE_DELETED = 'TM_STATE_DELETED';
export const TM_STATES_SET = 'TM_STATES_SET';
export const TM_INITIAL_STATE_CHANGED = 'TM_INITIAL_STATE_CHANGED';
export const TM_INITIAL_STATE_REMOVED = 'TM_INITIAL_STATE_REMOVED';
export const TM_ACCEPT_STATE_ADDED = 'TM_ACCEPT_STATE_ADDED';
export const TM_ACCEPT_STATE_REMOVED = 'TM_ACCEPT_STATE_REMOVED';
export const TM_ACCEPT_STATES_SET = 'TM_ACCEPT_STATES_SET';
export const TM_TRANSITION_ADDED = 'TM_TRANSITION_ADDED';
export const TM_TRANSITION_REMOVED = 'TM_TRANSITION_REMOVED';
export const TM_TAPE_SYMBOL_ADDED = 'TM_TAPE_SYMBOL_ADDED';
export const TM_TAPE_ALPHABET_SET = 'TM_TAPE_ALPHABET_SET';
export const TM_INPUT_SYMBOL_ADDED = 'TM_INPUT_SYMBOL_ADDED';
export const TM_INPUT_ALPHABET_SET = 'TM_INPUT_ALPHABET_SET;';
export const TM_BLANK_SYMBOL_CHANGED = 'TM_BLANK_SYMBOL_CHANGED';
export const TM_BLANK_SYMBOL_REMOVED = 'TM_BLANK_SYMBOL_REMOVED';
export const TM_INPUT_STRING_SET = 'TM_INPUT_STRING_SET';
export const TM_EXECUTION_PATH_SET = 'TM_EXECUTION_PATH_SET';
export const TM_STEP_INPUT = 'TM_STEP_INPUT';
export const TM_RUN_INPUT = 'TM_RUN_INPUT';
export const TM_RESTART_INPUT = 'TM_RESTART_INPUT';
export const TM_ADD_TEST_CASE = 'TM_ADD_TEST_CASE';
export const TM_REMOVE_TEST_CASE = 'TM_REMOVE_TEST_CASE';
export const TM_RUN_TEST_CASES = 'TM_RUN_TEST_CASES';
export const TM_RESET_TEST_CASES = 'TM_RESET_TEST_CASES';
export const TM_INITIALIZE_TEST_CASES_FROM_CSV_STRING = 'TM_INITIALIZE_TEST_CASES_FROM_CSV_STRING';
export const TM_INITIALIZED_FROM_JSON_STRING = 'TM_INITIALIZED_FROM_JSON_STRING';
export const TM_RESET = 'TM_RESET';

// regex
export const REGEX_SET = 'REGEX_SET';
export const REGEX_CLEARED = 'REGEX_CLEARED';
export const REGEX_INITIALIZED_FROM_JSON_STRING = 'REGEX_INITIALIZED_FROM_JSON_STRING';

// modal
export const MODAL_CREATED = 'MODAL_CREATED';
export const MODAL_REMOVED = 'MODAL_REMOVED';
export const MODAL_STATE_SET = 'MODAL_STATE_SET';

// settings
export const SETTINGS_DARK_THEME_SET = 'SETTINGS_DARK_THEME_SET';
export const SETTINGS_EMPTY_STRING_SYMBOL_SET = 'SETTINGS_EMPTY_STRING_SYMBOL_SET';
export const SETTINGS_ALTERNATION_SYMBOL_SET = 'SETTINGS_ALTERNATION_SYMBOL_SET';
export const SETTINGS_TEST_VIEW_SET = 'SETTINGS_TEST_VIEW_SET';


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js